import React, { useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import CreditMovementPage from "./credit-movement.page";
import {
    initCreditMovement,
    setCreditMovementPage,
    setCreditMovementRowsPerPage,
    setCreditMovementFilters,
    setSearchPrintJobId,
    resetCreditMovementFilters,
} from "modules/reporting/redux/slice/reportingCreditMovement.slice";
import { getCreditMovementListing, getProductSkuList } from "modules/reporting/redux/action";

// Default filters for clear action
const getDefaultFilters = () => ({
    searchPrintJobId: "",
    dateRange: {
        from: moment().subtract(2, 'weeks').format("YYYY-MM-DD"),
        to: moment().format("YYYY-MM-DD"),
    },
    productSku: null,
});

export default function CreditMovementContainer({ translate, language }) {
    const dispatch = useDispatch();

    // Get state from Redux
    const { listingData, pagination, filters, filterOptions } =
        useSelector((state) => state.reporting.creditMovement);

    // Fetch listing data
    const fetchListingData = useCallback((currentFilters, currentPagination) => {
        const dateRange = currentFilters.dateRange;

        dispatch(getCreditMovementListing({
            start_date: dateRange?.from || null,
            end_date: dateRange?.to || null,
            product_sku: currentFilters.productSku === "all" ? null : currentFilters.productSku,
            search: currentFilters.searchPrintJobId || null,
            start: currentPagination.page * currentPagination.rowsPerPage,
            length: currentPagination.rowsPerPage,
        }));
    }, [dispatch]);

    // Initialize and fetch on mount
    useEffect(() => {
        dispatch(initCreditMovement());
        dispatch(getProductSkuList());
        fetchListingData(filters, pagination);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handlePageChange = (newPage) => {
        dispatch(setCreditMovementPage(newPage));
        fetchListingData(filters, { ...pagination, page: newPage });
    };

    const handleRowsPerPageChange = (newRowsPerPage) => {
        dispatch(setCreditMovementRowsPerPage(newRowsPerPage));
        fetchListingData(filters, { ...pagination, rowsPerPage: newRowsPerPage, page: 0 });
    };

    const handleFilterChange = (filterUpdates) => {
        dispatch(setCreditMovementFilters(filterUpdates));
    };

    const handleApplyFilters = () => {
        dispatch(setCreditMovementPage(0));
        fetchListingData(filters, { ...pagination, page: 0 });
    };

    const handleSearchChange = (searchValue) => {
        dispatch(setSearchPrintJobId(searchValue));
    };

    const handleExport = () => {
        // TODO: Implement export functionality
        console.log("Exporting data...");
    };

    const handleClearFilters = () => {
        const defaultFilters = getDefaultFilters();
        dispatch(resetCreditMovementFilters());
        fetchListingData(defaultFilters, { ...pagination, page: 0 });
    };

    return (
        <CreditMovementPage
            listingData={listingData}
            pagination={pagination}
            filters={filters}
            filterOptions={filterOptions}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleRowsPerPageChange}
            onFilterChange={handleFilterChange}
            onApplyFilters={handleApplyFilters}
            onSearchChange={handleSearchChange}
            onExport={handleExport}
            onClearFilters={handleClearFilters}
            translate={translate}
            language={language}
        />
    );
}
